// Module
var code = "<add-insurance ai-on-complete=\"onComplete()\" ai-title=\"{{ ::windowTitle }}\"></add-insurance>";
// Exports
var _module_exports = code;;
var path = 'template/settings/tabs/insurance/upload-insurance.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;